export default __webpack_public_path__ + "static/media/rtcomputingsw.9717bef8.png";